import { render, staticRenderFns } from "./open-sign-up.vue?vue&type=template&id=3331f786&"
import script from "./open-sign-up.vue?vue&type=script&lang=js&"
export * from "./open-sign-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports